<template>
	<div class='inspection-geometry'>
		<div class='flex-container'>
			<div>

				<!-- <MapTest :abris-points='actPointList'/> -->

				<LoadAbrisBlock/>
				<LegendBlock v-model='legendIsOpen'/>
				<AddBlock class='add-block-outer'/>

				<div v-if='!actPointList.length'>
					<span>Координаты участка еще не добавлены</span>
				</div>

				<table v-else class='table-def table-points'>
					<thead>
						<tr>
							<th>№</th>
							<th>Широта</th>
							<th>Долгота</th>
							<th><button class='remove-btn' @click='removeAll' :disabled='!actLpoIsDraft'>удалить все</button></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for='point in actPointList' :key='point.id'>
							<td>{{ point.point_num }}</td>
							<td>{{ point.lat }}</td>
							<td>{{ point.lon }}</td>
							<td><button class='remove-btn' @click='remove(point)' :disabled='!actLpoIsDraft'>удалить</button></td>
						</tr>
					</tbody>
				</table>

				<LoadCoordBlock/>

			</div>

			<div class='map-container flex-item'>
				<MapComponent :abris-points='actPointList' :actStrips='actStrips' :actTrack='actTrack' :lpoGeoms='lpoGeoms' ref='map'/>
				<div class="track-container">
					<label>
						<span class='custom-track-load'>Загрузить трек (.gpx .kml)</span>
						<input style='display: none;' type='file' @input='onTrackLoaded' accept='.gpx,.kml' ref='act-track'/>
						<button class='custom-track-load' @click='removeTrack'>Удалить трек</button>
					</label>
				</div>
			</div>
		</div>

		

<!-- 		<div class='map-container'>
			<MapComponent :abris-points='actPointList' ref='map'/>
		</div> -->

	</div>
</template>

<script>
	const LOAD_TRACK = process.env.VUE_APP_ROOT_API + 'load_file/load_track.php';
	import { mapState, mapMutations, mapActions } from "vuex";
	import LoadAbrisBlock from './ActGeometry__loadAbris';
	import LoadCoordBlock from './ActGeometry__loadCoords';
	import AddBlock from './ActGeometry__addBlock';
	import MapComponent from '../../MapComponent';
	import LegendBlock from './ActGeometry__legend';

	import MapTest from './MapTest';

	export default {
		name: 'InspectionGeometry',
		components: {
			LoadAbrisBlock,
			LoadCoordBlock,

			AddBlock,
			MapComponent,
			LegendBlock,

			MapTest
		},

		data: () => ({
			legendIsOpen: false,
		}),

		computed: {
			...mapState('selectedLpo', {
				selectedLpo: state => state.lpo
			}),
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			actPointList() {
				return this.$store.state.actLpo.geometry.actPointList;
			},
			actStrips() {
				return this.$store.state.actLpo.geometry.actStrips;
			},
			actTrack() {
				return this.$store.state.actLpo.geometry.actTrack;
			},
			lpoGeoms() {
				return this.$store.state.actLpo.geometry.lpoGeoms;
			},
			map() {
				return this.$refs['map'];
			}
		},

		watch: {
			pointList(val) {
				// this.updateLpo();
			}
		},

		methods: {
			...mapMutations("lpoData", ["clearCurrentLpoData"]),

    		...mapActions("lpoData", ["getCurrentLpoData"]),

    		...mapActions("currentLpo", ["getCurrentLpo"]),
			removeAll() {
				this.removeAllPoints().then(res => {
					this.getActPointList();
					this.getActGeometries();
				});
			},
			remove(point) {
				this.removePoint(point).then(res => {
					this.getActPointList();
				});
			},

			...mapActions('actLpo', [
				'getActGeometries',
				'getActPointList',
				'removePoint',
				'removeAllPoints',
				'addTrack',
				'removeTrack'
			]),
			onTrackLoaded() {
				const inputFile = this.$refs['act-track'].files[0];

				if (!inputFile) {
					this.$toast.add({severity: 'warn', detail: 'Файл не выбран', life: 10000});
					return;
				}

				const form = new FormData();

				form.append('track', inputFile);
				form.append('lease_id', this.selectedLpo.lease_id);

				fetch(LOAD_TRACK, {
					credentials: 'include',
					method: 'post',
					body: form,
				}).then(res => res.json())
				.then(res => {
					this.addTrack(res.track)
					//this.$store.state.actLpo.geometry.actTrack = res.track
					//this.coordList = res;
					//this.openModal();

				})
				.catch(err => {
					throw err;
				})
				.finally(() => {
					this.$refs['act-track'].value = null;
				});
			},
		},
		created() {
			this.getActPointList();
			this.getActGeometries();
		}
	};
</script>

<style scoped src='@/style/flex.css'></style>
<style scoped src='@/style/table.css'></style>

<style scoped>
	.map-container {
		/*border: 1px solid black;*/
	}

	.track-container {
		position: relative;
	}

	.custom-track-load {
		display: inline-block;
		padding: 4px 14px;
		background-color: #169972;
		color: white;
		cursor: pointer;
		margin: 10px 0 20px 0;
		border: 0ch;
		margin-right: 10px;
	}

	.flex-container {
		gap: 20px;
	}

	.table-points {
		width: 400px;
		margin-top: 40px;
	}

	.add-block-outer {
		width: 400px;
	}

	.s-block-outer {
		margin-top: 30px;
	}
	.custom-load-input {
		border-radius: 5px;
		display: inline-block;
		padding: 4px 14px;
		background-color: blue;
		color: white;
		cursor: pointer;
		margin: 10px 0 20px 0;
	}
</style>